import { config } from '@/config.js'
import { sendGatewayRequest } from '@/services/gatewayApi.js'

const UTM_STORAGE_KEY = 'utm'

function readStoredUtm() {
  try {
    const raw = localStorage.getItem(UTM_STORAGE_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}

function saveUtm(params) {
  localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(params))
}

function waitForYm(timeoutMs = 4000) {
  return new Promise((resolve) => {
    if (typeof window.ym === 'function') {
      resolve(true)
      return
    }

    const started = Date.now()
    const timer = setInterval(() => {
      if (typeof window.ym === 'function') {
        clearInterval(timer)
        resolve(true)
        return
      }
      if (Date.now() - started >= timeoutMs) {
        clearInterval(timer)
        resolve(false)
      }
    }, 50)
  })
}

function getYmClientId(metrikaId, timeoutMs = 3000) {
  return new Promise((resolve) => {
    let done = false
    const finish = (id) => {
      if (done) return
      done = true
      resolve(id ?? null)
    }

    setTimeout(() => finish(null), timeoutMs)
    window.ym(metrikaId, 'getClientID', (clientID) => finish(clientID))
  })
}

export async function initUtm(store) {
  const metrikaId = config.yandexMetrikaId
  const urlParams = new URLSearchParams(window.location.search)
  const fromUrl = {}

  for (const [key, value] of urlParams) {
    fromUrl[key] = value
  }

  const params = {
    ...readStoredUtm(),
    ...fromUrl,
    utm_source: window.location.hostname,
  }

  if (window.location.href) {
    params.landing = window.location.href.split('#')[0]
  }
  if (document.referrer) {
    params.referrer = document.referrer
  }

  saveUtm(params)

  const ymReady = await waitForYm()
  if (ymReady) {
    const clientID = await getYmClientId(metrikaId)
    if (clientID) {
      params.yandexClientID = clientID
      params.counterId = metrikaId
      saveUtm(params)
    }
  }

  try {
    const data = await sendGatewayRequest({ path: '/api/click', ...params })
    if (data?.utm_id) {
      params.utm_id = data.utm_id
      saveUtm(params)
      store.commit('setUtm', params.utm_id)
    }
    store.commit('setBot')
    return params.utm_id ?? null
  } catch (error) {
    console.log(error)
    store.commit('setBot')
    return params.utm_id ?? null
  }
}
